export function trim(string = '') {
  return string.toString().replace(/(^\s+)|(\s+$)/gi, '');
}

export function paraphrase(content = '', maxLength = 140) {
  content = trim(content).replace(/\s+/gi, ' ');

  const originalLength = content.length;
  let endIndex = (`${content} `).lastIndexOf(' ', maxLength);

  if (endIndex < 0) {
    endIndex = originalLength;
  }

  content = content.slice(0, endIndex);

  // Just return it if the original string was short enough
  // If the line ends with a line end, then just return the content
  if (content.length === originalLength || ['.', '!', '?'].indexOf(content.slice(-1)) > -1) {
    return content;

    // Otherwise append ellipsis
  }
  return `${content}...`;
}
